import { map } from "rxjs/operators";
import { HouseholdRepository } from "src/containers/household/repositories/household/household.repository";
import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";

import { autoBind } from "src/shared/decorators/autobind";
import { Building } from "src/shared/models/building.model";

@injectable()
export class HouseholdService {
    constructor(
        @inject("HouseholdRepository") private repository: HouseholdRepository
    ) {}

    @autoBind
    getBuildings(
        userIdentity: string,
        policyId: number
    ): Observable<Building[]> {
        return this.repository
            .getBuildings(userIdentity, policyId)
            .pipe(
                map((buildings) =>
                    buildings.map((building) =>
                        Building.fromJson<Building>(building)
                    )
                )
            );
    }
}
